import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Dropdown, Menu, Pagination, Row, Select, Table } from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

// import { setLoading } from "../../../../redux/store/common/commonDuck";

const SellerCase = ({
  targetYear,
  setTargetYear,
  targetMonth,
  setTargetMonth,
  orderList,
  summary,
  selectInfluencer,
  totalSize,
  pageSize,
  setPageSize,
  setOffset,
  currentPageNumber,
  setCurrentPageNumber,
}) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  // const setIsLoading = (value) => dispatch(setLoading(value));
  const [commissionList, setCommissionList] = useState([]);

  const [iconShow, setIconShow] = useState(false);

  useEffect(() => {
    if (orderList?.length > 0) {
      setCommissionList([...orderList]);
    } else {
      setCommissionList([]);
    }
  }, [orderList]);

  const [noticeList, setNoticeList] = useState([
    { title: "정산 월", data: "04월" },
    { title: "매출액", data: 0 },
    { title: "확정수익", data: 0 },
    { title: "정산금액", data: 0 },
  ]);

  useEffect(() => {
    let list = [...noticeList];
    list[0].data = targetMonth + "월";
    setNoticeList(list);
  }, [targetMonth]);

  useEffect(() => {
    let list = [...noticeList];
    list[1].data = summary.total;
    list[2].data = summary.profit;
    // list[3].data = summary.profit;
    list[3].data = summary.commission;
    setNoticeList(list);
  }, [summary]);

  const columns = [
    {
      title: "주문번호",
      dataIndex: "order_id",
      key: "order_id",
      width: 100,
      align: "center",
    },
    {
      title: "상품주문번호",
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      align: "center",
      width: 100,
    },
    {
      title: "구분",
      dataIndex: "type",
      key: "type",
      align: "center",
      width: 80,
      render: (value) => {
        // return value === 1 ? "상품주문" : "배송비"
        return "상품주문";
      },
    },
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
      ellipsis: true,
      width: 200,
      render: (value, record) => {
        if (value && record) {
          return value + ` - ${record?.option_title}`;
        }
      },
    },
    {
      title: "구매자명",
      dataIndex: "name",
      key: "name",
      align: "center",
      width: 100,
      render: (value) => {
        if (value) {
          if (value?.length < 3) {
            return value?.slice(0, 1) + "*";
          } else {
            return value?.slice(0, 1) + "*" + value?.charAt(value?.length - 1);
          }
        } else {
          return null;
        }
      },
    },
    {
      title: "정산 금액",
      dataIndex: "",
      key: "",
      align: "center",
      render: (value) => {
        if (value) {
          let vat = value?.vat;
          let profit = value.total_price * (value.commission_rate / 100);
          // let tax = vat ? profit * 0.1 : profit * 0.033;
          // let tax = vat ? Math.round(profit * 0.1) : Math.round(profit * 0.033);
          let tax = vat ? 0 : Math.round(profit * 0.033);
          let calculate = vat ? profit + tax : profit - tax;
          return (
            <p className={`blue`}>{Math.round(calculate).toLocaleString()}</p>
          );
        }
      },
    },
    {
      title: "수익 금액",
      dataIndex: "",
      key: "",
      align: "center",
      render: (value) => {
        if (value) {
          return (
            <p>
              {Math.round(
                value.total_price * (value.commission_rate / 100),
              ).toLocaleString()}
            </p>
          );
        }
      },
    },
    {
      title: "판매 금액",
      dataIndex: "total_price",
      key: "total_price",
      align: "center",
      render: (value, record) => {
        if (value) {
          return <p>{value.toLocaleString()}</p>;
        }
      },
    },
    {
      title: "수익율",
      dataIndex: "commission_rate",
      key: "commission_rate",
      align: "center",
      render: (value, record) => {
        return <p>{value.toLocaleString()}%</p>;
      },
    },
    // {
    //     title: `${orderList[0]?.vat ? "부가가치세" : "원천세"}`,
    //     dataIndex: '',
    //     key: '',
    //     align: "center",
    //     render: (value, record) => {
    //         let vat = value?.vat;
    //         let profit = (value.total_price * (value.commission_rate / 100));
    //         let tax = vat ? Math.round(profit * 0.1) : Math.round(profit * 0.033);
    //         if (value) {
    //             if (vat) {
    //                 return (
    //                     <p className={`red`}>
    //                         {tax.toLocaleString()}
    //                     </p>
    //                 )
    //             } else {
    //                 return (
    //                     <p className={`red`}>
    //                         -{tax.toLocaleString()}
    //                     </p>
    //                 )
    //             }
    //         }
    //     }
    // },
    {
      // title: '결제일',
      title: "구매확정일",
      dataIndex: "complete_date",
      key: "complete_date",
      align: "center",
      render: (value) => {
        if (value) {
          return <p>{moment(value).format("YYYY.MM.DD HH:mm")}</p>;
        }
      },
    },
  ];

  const handleMonth = (value) => {
    let list = [...noticeList];
    list[0].data = value + "월";
    setNoticeList([...list]);
    setTargetMonth(value);
  };

  const dropdownItems = (
    <Menu>
      <Menu.Item
        style={{ fontSize: "0.9em" }}
        onClick={() => {
          setOffset(0);
          setCurrentPageNumber(0);
          setPageSize(10);
        }}
      >
        10개씩 보기
      </Menu.Item>
      <Menu.Item
        style={{ fontSize: "0.9em" }}
        onClick={() => {
          setOffset(0);
          setCurrentPageNumber(0);
          setPageSize(20);
        }}
      >
        20개씩 보기
      </Menu.Item>
      <Menu.Item
        style={{ fontSize: "0.9em" }}
        onClick={() => {
          setOffset(0);
          setCurrentPageNumber(0);
          setPageSize(30);
        }}
      >
        30개씩 보기
      </Menu.Item>
    </Menu>
  );

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    if (pageNumber > 0) {
      const currOffset = (pageNumber - 1) * pageSize;
      setCurrentPageNumber(pageNumber);
      setOffset(currOffset);
    }
  };

  const pageSizeChange = (current, pageSize) => {
    setOffset((current - 1) * 10);
    setPageSize(pageSize);
    setCurrentPageNumber(1);
  };
  return (
    <>
      <Row
        className="product-register-border-box"
        justify={"space-between"}
        wrap={false}
        style={{ marginTop: 20, borderBottom: 0 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="product-register-box-title">정산내역 및 목록</span>
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#117ffa" }}>
            구매확정(배송완료일로부터 7일 후)을 기준으로 정산기준일 +1영업일째
            되는 날 정산 된 내역만 표기되어 매출액과 상이할 수 있습니다.
          </p>
        </div>
      </Row>
      <div
        className="product-register-border-box"
        wrap={false}
        style={{ padding: "20px 25px 40px", height: "fit-content" }}
      >
        <div className={`commission-year-select`}>
          <p>정산년도</p>
          <Select
            value={targetYear}
            onChange={(value, option) => {
              setTargetYear(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 년도"}
          >
            {["2022", "2023", "2024"]?.map((item) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
          <Select
            value={targetMonth}
            onChange={(value, option) => {
              handleMonth(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 년도"}
          >
            {Array.from({ length: 12 })?.map((item, idx) => (
              <Option
                key={idx + 1}
                value={idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              >
                {idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              </Option>
            ))}
          </Select>
        </div>

        <div className={`commission-notice-div`}>
          {noticeList?.map((item, idx) => (
            <div
              className={`commission-notice-each`}
              key={`commission-notice-each-${idx}`}
              style={{
                position: "relative",
              }}
            >
              <p className={`title`}>{item.title}</p>
              {idx === 3 ? (
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <p className={`data`}>
                    {idx > 0 ? item.data?.toLocaleString() + "원" : item.data}
                  </p>

                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/images/commission/notice.png`}
                    alt={`faq 접기열기 아이콘`}
                    width={16}
                    height={16}
                    style={{ cursor: "pointer" }}
                    onClick={() => setIconShow(!iconShow)}
                  />
                  {iconShow && (
                    <div className={`commission-absolute`}>
                      <p>· 원천세(개인) : -3.3%</p>
                      {/*<p>· 부가가치세(사업자,법인) : +10%</p>*/}
                      <p>· 부가가치세 포함</p>
                    </div>
                  )}
                </div>
              ) : (
                <p className={`data`}>
                  {idx > 0 ? item.data?.toLocaleString() + "원" : item.data}
                </p>
              )}
            </div>
          ))}
        </div>
        <Row
          justify={"space-between"}
          align={`middle`}
          style={{ marginBottom: "1em" }}
        >
          <p
            style={{
              fontWeight: "500",
              margin: 0,
            }}
          >
            목록 {summary?.complete_num ?? 0}건
          </p>
          <Button
            className="order-excel-download-btn"
            icon={
              <img
                style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                alt={`엑셀이미지`}
              />
            }
            style={{
              marginLeft: "auto",
            }}
            // onClick={handleExcelDownloadClick}
          >
            엑셀다운
          </Button>
        </Row>
        <Table
          className={`commission-table`}
          // rowSelection={rowSelection}
          columns={columns}
          dataSource={selectInfluencer.id?.length !== 0 ? commissionList : []}
          loading={isLoading}
          bordered
          size="small"
          rowKey="order_detail_id"
          rowClassName="coupon-table-row"
          // scroll={{x: 'calc(700px + 50%)'}}
          // onChange={tableOnChange}
          pagination={false}
        />

        <div style={{ textAlign: "right" }}>
          <Pagination
            showQuickJumper
            showSizeChanger
            onShowSizeChange={pageSizeChange}
            style={{ marginTop: 20 }}
            current={currentPageNumber}
            pageSize={pageSize}
            total={totalSize}
            onChange={handleChangePagination}
          />
        </div>
      </div>
    </>
  );
};
export default SellerCase;
